export const bdGetters = {
    // distributorList: state => state.bd.distributorList,
    distributorList:state=>{
        // console.log('aaa',state.analysis);
        const distributorList = state.bd.distributorListSet[0] ?? [];
        // console.log('aaaaaaaaaaaaaaa',state.analysis.Analysis_Month_Week[0])
        // return createChartData({series: Analysis_Month, xName: '月份'})
        return distributorList;
    },

    finalUserWithDistributeList:state=>{
        // console.log('aaa',state.analysis);
        const finalUserWithDistributeList = state.bd.distributorListSet[1] ?? [];
        // console.log('aaaaaaaaaaaaaaa',state.analysis.Analysis_Month_Week[0])
        // return createChartData({series: Analysis_Month, xName: '月份'})
        return finalUserWithDistributeList;
    },


    finalUserList:state=>{
        const finalUserList = state.bd.finalUserListSet[0] ?? [];
        return finalUserList;
    },

    callLogList:state => state.bd.callLogList,

    emailLogList:state => state.bd.emailLogList,
};